if (!customElements.get('benefits-row')) {
  const mobile = window.matchMedia('(max-width: 749px)');

  class BenefitsRow extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.benefits__track');
      this.dots = [...this.querySelectorAll('.benefits__dot')];
      if (!this.track || !this.classList.contains('benefits--carousel')) return;

      this.onScroll = () => this.updateDots();
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      // Pause auto-rotate while the shopper is touching the carousel.
      this.track.addEventListener('pointerdown', () => this.stop());
      this.track.addEventListener('touchstart', () => this.stop(), { passive: true });
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    get items() {
      return [...this.track.children];
    }

    currentIndex() {
      const center = this.track.scrollLeft + this.track.clientWidth / 2;
      let best = 0;
      this.items.forEach((item, i) => {
        const itemCenter = item.offsetLeft + item.offsetWidth / 2;
        if (Math.abs(itemCenter - center) < Math.abs(this.items[best].offsetLeft + this.items[best].offsetWidth / 2 - center)) best = i;
      });
      return best;
    }

    updateDots() {
      const index = this.currentIndex();
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    }

    start() {
      if (this.dataset.autoplay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const seconds = Number(this.dataset.autoplaySpeed) || 4;
      this.timer = setInterval(() => {
        if (!mobile.matches || this.items.length < 2) return;
        const next = (this.currentIndex() + 1) % this.items.length;
        const item = this.items[next];
        this.track.scrollTo({ left: item.offsetLeft - (this.track.clientWidth - item.offsetWidth) / 2, behavior: 'smooth' });
      }, seconds * 1000);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  customElements.define('benefits-row', BenefitsRow);
}
